<template>
  <b-modal ref="modal" :hideFooter="true" size="md" @hidden="onHide" :title="modalTitle">
    <div v-if="tasks && tasks.length">
      <div class="row">
        <div class="col-12 mb-4 bill-separately__container" v-if="tasks.length > 1 && this.separateBills.length">
          <span>Bill each task separately:</span>
          <i class="far fa-square"
             v-if="!billSeparately"
             @click="toggleBillSeparately"></i>
          <i class="far fa-check-square"
             v-else
             @click="toggleBillSeparately"></i>
        </div>
      </div>
      <div class="row info my-1" v-for="task in tasks">
        <div class="col-3">
          <i class="far fa-user icon"></i> {{ task.client.name }}
        </div>
        <div class="col">
          <span><i class="fas fa-suitcase icon"></i> {{ task.project.name }}</span>
          <span v-if="tasks.length > 1 && task.fixed_price"> <strong>({{ isSimple ? '$' : task.fixed_price + ' €'}})</strong></span>
        </div>
        <div class="col" v-if="billSeparately && !task.fixed_price">
          <duration-picker
            :default="getDefaultTime(task)"
            @durationPicked="updateSeparateBill(task, $event)"
          ></duration-picker>
        </div>
      </div>

      <hr>

      <div class="row mt-3">
        <div class="col-12" v-if="tasks.length === 1">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>2D Pvsyst project count:</label>
                <input type="number" class="form-control" v-model="representativeTask.project.pvsyst_2d" min="0" step="1">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>3D Pvsyst project count:</label>
                <input type="number" class="form-control" v-model="representativeTask.project.pvsyst_3d" min="0" step="1">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <template v-if="isAdmin || isManager">
              <template v-if="this.tasks.length === 1 && this.representativeTask.fixed_price">
                <label>Fixed price:</label>
                <input type="text" class="form-control" :value="this.representativeTask.fixed_price + ' €'" disabled>
              </template>
              <template v-else-if="this.tasks.length === 1 || this.separateBills.length">
                <label>Hours to bill</label>
                <duration-picker
                  :default="secondsToBill"
                  :disabled="billSeparately"
                  @durationPicked="secondsToBill = $event"
                ></duration-picker>
              </template>
            </template>
            <template v-else>
              <template v-if="isProjectFixed">
                <h5 class="bold mt-3">This project is fixed price.</h5>
              </template>
              <template v-else>
                <label>Engineered for</label>
                <duration-picker
                  :default="secondsToBill"
                  @durationPicked="secondsToBill = $event"
                ></duration-picker>
              </template>
            </template>
          </div>
        </div>
      </div>

      <div class="text-center mt-3">
        <button class="btn btn-success mr-1 custom-button" :disabled="!secondsToBill" @click="onBill">
          <template v-if="!isAdmin && !isManager && isProjectFixed">
            DONE
          </template>
          <template v-else>
            BILL
          </template>
        </button>
        <a class="btn btn-default custom-button" @click="onBack">BACK</a>
      </div>

    </div>
  </b-modal>
</template>

<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import DurationPicker from '../../components/partials/DurationPicker.vue'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      'b-modal': bModal,
      'duration-picker': DurationPicker
    },
    data() {
      return {
        tasks: [],
        secondsToBill: null,
        representativeTask: null,
        billSeparately: false,
        separateBills: [],
        isProjectFixed: false
      }
    },
    created() {
      this.$root.$on('bill-tasks', this.open)
    },
    computed: {
      ...mapGetters('auth', ['isAdmin', 'isManager', 'isSimple']),
      modalTitle() {
        if (this.isAdmin || this.isManager) {
          return 'Billable hours'
        } else {
          if (this.representativeTask && this.isProjectFixed) {
            return 'Finish task'
          } else {
            return 'Engineered hours'
          }
        }
      }
    },
    methods: {
      open(tasks) {
        if (!Array.isArray(tasks))
          tasks = [tasks]

        this.tasks = tasks

        if (this.tasks.length < 1) {
          return
        }

        this.representativeTask = this.getRepresentativeTask()
        this.secondsToBill = this.getTaskTimestring(this.representativeTask)
        this.createSeparateBillArray()
        this.isProjectFixed = this.isProjectFixedPrice()

        if (this.$refs.modal)
          this.$refs.modal.show()
      },

      hide() {
        this.onHide()
        this.$refs.modal.hide()
      },

      onHide() {
        this.tasks = null
        this.secondsToBill = null
        this.billSeparately = false
        this.separateBills = []
      },

      getTaskTimestring(task) {
        const time = task.done ? task.engineering_hours : task.duration
        return this.$root.secondsToTimestring(time)
      },

      onBill() {
        this.secondsToBill = this.timeToSeconds(this.secondsToBill)

        const data = {
          task_id: this.tasks.map(task => task.id),
          secondsToBill: this.secondsToBill || 0,
          pvsyst_2d: this.representativeTask.project.pvsyst_2d,
          pvsyst_3d: this.representativeTask.project.pvsyst_3d
        }

        if (this.billSeparately) {
          data.separateBills = [];
          this.separateBills.forEach(bill => {
            data.separateBills.push({
              taskId: bill.taskId,
              seconds: this.timeToSeconds(bill.time)
            })
          })
        }

        this.axios.post('/tasks/bill', data)
          .then(res => {
            const tasks = res.data.data
//            tasks.forEach(task => this.$root.$emit('taskBilled', task))
            this.$root.$emit('load-agenda')
            this.hide()
          })
      },

      onBack() {
        if (this.tasks.length === 1) {
          this.$emit('backToTask', this.representativeTask.id)
        }
        this.hide()
      },

      timeToSeconds(time) {
        let seconds;

        if (!Number.isInteger(time)) {
          const timeArray = time.split(':')
          seconds = parseInt(timeArray[0]) * 3600 + parseInt(timeArray[1]) * 60
        }

        return seconds
      },

      getRepresentativeTask() {
        let task = this.tasks.find(task => task.fixed_price <= 0)
        if (!task)
          task = this.tasks.find(task => task.fixed_price)

        return task
      },

      toggleBillSeparately() {
        this.billSeparately = !this.billSeparately;
      },

      createSeparateBillArray() {
        const hourlyTasks = this.tasks.filter(task => !task.fixed_price)
        this.separateBills = hourlyTasks.map(task => {
          return {
            taskId: task.id,
            time: this.getTaskTimestring(task)
          }
        })
      },

      getDefaultTime(task) {
        let time = '';
        const bill = this.separateBills.find(bill => bill.taskId === task.id)

        if (bill)
          time = bill.time

        return time
      },

      updateSeparateBill(task, time) {
        this.separateBills = this.separateBills.map(bill => {
          if (bill.taskId === task.id) {
            bill.time = time
          }

          return bill
        })
      },
      isProjectFixedPrice() {
        if (!this.representativeTask) return false

        return this.representativeTask.project.fixed_price > 0
      }
    },
  }
</script>

<style scoped>
  .info > div:first-child {
    border-right: 1px #D0D0D0 solid;
  }

  .custom-button {
    width: 33%
  }

  .custom-button[disabled] {
    cursor: not-allowed;
  }

  .bill-separately__container {
    display: flex;
    align-items: center;
  }

  .bill-separately__container .far {
    margin-left: 5px;
    font-size: 1.5rem;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/views/agenda/BillableHours.vue